import { UnsavedUser, User, UserRoleSet } from '@paragon/contract-library';

import { UserService } from '../connections';

export async function fetch(userEmail: string): Promise<User> {
  return UserService.get(`users/${userEmail}`);
}

export function fetchAll() {
  return UserService.get<{ readonly users: readonly User[] }>('users').then((response) => response.users);
}

export function fetchAllInOrganization(organization: string) {
  return UserService.get<{ readonly users: readonly User[] }>('users', {
    params: new URLSearchParams({ organization }),
  }).then((response) => response.users);
}

export async function updatePassword(userEmail: string, newPassword: string) {
  return UserService.patch(`users/${userEmail}`, { data: { password: newPassword } });
}

export async function updateRoleSet(userEmail: string, roleSet: UserRoleSet): Promise<User> {
  return UserService.patch(`users/${userEmail}`, { data: { roleSet } });
}

export function update(
  email: string,
  firstName: string,
  lastName: string,
  phone: string,
  roleSet: UserRoleSet,
  organization: string,
  location: string,
  trialEndDate: string | null,
) {
  return UserService.patch<User>(`users/${email}`, {
    data: {
      email,
      firstName,
      lastName,
      phone,
      roleSet,
      organization,
      location,
      trialEndDate,
    },
  });
}

export function create(record: UnsavedUser) {
  return UserService.post<User>('users', { data: record });
}

export function startFreeTrial(forEmail?: string) {
  return UserService.post<User>('users/startFreeTrial', { data: { email: forEmail } });
}
